import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=12b1ce4a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=12b1ce4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1ce4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b1ce4a')) {
      api.createRecord('12b1ce4a', component.options)
    } else {
      api.reload('12b1ce4a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=12b1ce4a&scoped=true&", function () {
      api.rerender('12b1ce4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V96e0qqhf1v3/JS/comp/SearchFilterTokens.vue"
export default component.exports